import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {useAppStore} from '../../../../stores/AppStore/useAppStore'
import {useRouteStore} from '../../../../stores/RouteStore/useRouteStore'
import {useDatabaseItemLayoutStore} from '../../../../stores/DatabaseItemLayoutStore/useDatabaseItemLayoutStore'
import {useResponsive} from '../../../../composables/useResponsive'
import {getIsDatabaseItemSidebarNavigation} from '../../../../modules/databases/functions/getIsDatabaseItemSidebarNavigation'
import {getStackableLayerCountWithoutFilePreviews} from '../../../../modules/routes/functions/getStackableLayerCountWithoutFilePreviews'

export function startPageLoadingRouterHookFactory(pinia: Pinia) {
  return async function startPageLoadingRouterHook(to: RouteLocationNormalized, from: RouteLocationNormalized) {
    const appStore = useAppStore(pinia)
    // The sidebar shows the item at once; dimming the page while only the address follows would block it.
    const routeStore = useRouteStore(pinia)
    const databaseItemLayoutStore = useDatabaseItemLayoutStore(pinia)
    if(getIsDatabaseItemSidebarNavigation({
      to,
      from,
      baseRoute: routeStore.lastNonStackableRoute,
      layerCount: getStackableLayerCountWithoutFilePreviews(routeStore.stackableRoutes),
      isSmallScreen: useResponsive().isSmallerThanLarge.value,
      getLayout: databaseItemLayoutStore.getSourceLayout,
    })) {
      return
    }
    appStore.isPageLoading = true
  }
}
